import { CommonButton } from './CommonButton';
import { CircularProgress } from '@mui/material';

interface ExportExcelButtonProps {
  onClick: () => void | Promise<void>;
  loading?: boolean;
}

export const ExportExcelButton = ({ onClick, loading = false }: ExportExcelButtonProps) => {
  return (
    <CommonButton onClick={onClick} disabled={loading}>
      {loading ? <CircularProgress size={20} color="inherit" /> : '암호화 ZIP 다운로드'}
    </CommonButton>
  );
};
